import { useEffect, useState } from "react";
import Common from "../../../helper/common";
import { Button } from "../../../components/ui/button";
import { Icon } from "@iconify/react";
import AdvanceTable from "../../../components/advanceTable";

import AddOpenMatchClub from "./addopenMatchClub";
// import { BookingCancellationReasonTypeEnum } from "../../constants/appConstant";
const OpenMatchClub = () => {
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    const [refId, setRefId] = useState(null);
    useEffect(() => {
        if (!open && refId) {
            setRefId();
        }
    }, [open, refId]);
    useEffect(() => {
        getData();

    }, [

    ]);
    const getData = async (
        pageNumber,
        searchTerm = "",
        recordsToDisplay = null
    ) => {


        const response = await Common.ApiService.getInstance().request(
            "GetOpenMatchClubList",
            {
                pageNumber: pageNumber,
                q: searchTerm,
                isactive: true,
                recordsToDisplay,
            },

            "Post"
        );

        if (response?.data) {
            let obj = {
                ...response.data[0],
                data: response.data[0].data.map((item) => ({
                    ...item,
                    clubName: item.clubName ?? "-",
                    createdByName: item.createdByName ?? "-",
                    //    logo: item.logo == null ? "-" : item.logo,
                    //    start_datetime: Common.Utility.ConvertTime(item.start_datetime),
                    //    end_datetime: Common.Utility.ConvertTime(item.end_datetime),

                })),
            };

            setData(obj);
        }
    };
    const columns = [
        {
            title: "Club logo",
            type: "image",
            isVisible: true,
            key: "logo",
        },
        { title: "Club Name", type: "text", isVisible: true, key: "name" },
        { title: "Linked Club", type: "text", isVisible: true, key: "clubName" },
        { title: "Created By", type: "text", isVisible: true, key: "createdByName" },



    ];
    const actions = [
        {
            type: "edit",
            onClick: (val) => _onEdit(val.id),
        },
        {
            type: "delete",
            onClick: (val) => _handleDelete(val.id),
        },
    ];
    const _onEdit = async (id) => {
        setOpen(true);
        setRefId(id);
    };
    const _handleDelete = async (id) => {
        const isConfirmed = await Common.SweetAlert.confirmation(
            "Are you sure want to delete this Open Match??",
        );

        if (isConfirmed) {
            let resp = await Common.ApiService.getInstance().request(
                `DeleteOpenMatchClub?id=${id}`,
                {},
                "Delete"
            );

            Common.SweetAlert.alert(resp.message, "success");

            setTimeout(() => {
                getData(1);
            }, 500);
        }
    };
    const _addUpdateTrigger = () => {
        <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
            <Icon icon="heroicons:pencil" className="h-4 w-4" />
        </Button>;
    };
    return (
        <>
            {data?.data && (
                <AdvanceTable
                    title={"Open Matches"}
                    columns={columns.filter((item) => item.isVisible)}
                    data={data}
                    getData={getData}
                    addButton={() => (
                        <AddOpenMatchClub
                            id={refId}
                            onClose={() => getData()}
                            open={open}
                            setOpen={setOpen}
                        />
                    )}
                    showPagination
                    showAddButton
                    actionButtons={actions}
                    updateTrigger={_addUpdateTrigger}
                />
            )}
        </>
    );
};
export default OpenMatchClub;
